<script>
    import { warehouseMethods, inventoryMethods } from '@state/helpers'
    import Multiselect from 'vue-multiselect'
    import { mapGetters } from 'vuex'
    let _ = require('lodash')
    
    export default {
      name: 'MultiSelectWarehouse',
      components: { Multiselect },
        props: {
        label_cols_xl: {
          type: Number,
          required: false,
          default: 3,
        },
        content_cols_xl: {
          type: Number,
          required: false,
          default: 9,
        },
        onlyWithLocations: {
          type: Boolean,
          required: false,
          default: false
        }
      },
      data() {
        return {
            own_select_warehouse: null,
        }
      },
      computed: {
        ...mapGetters({
          loading_warehouses: 'retina/warehouse/loading_warehouses',
          own_warehouses: 'retina/warehouse/own_warehouses',
        }),
        own_warehouse_selected: {
          get: function() {
              return this.$store.getters['retina/warehouse/own_warehouse_selected']
          },
          set: function(value) {
              this.$store.dispatch('retina/warehouse/own_warehouse_selected', value)
          }
        },
        transformedWarehouses() {
          return this.own_warehouses.map((item) => {
            let text = item.description
            if(item.status_own_inventory)text = item.description+' (PENDIENTE)'
            return {
              ...item,
              text,
            };
          });
        },
      },
      methods: {
        ...warehouseMethods,
        ...inventoryMethods,
        allWarehouse() {
          this.setLoadingWarehouses(true)
          return this.fetchOwnWarehouses(this.onlyWithLocations ? '?only_with_locations=true' : null)
            .then((data) => {
              this.setOwnWarehouses(data.results)
              this.setLoadingWarehouses(false)
            })
            .catch((error) => {
              this.$axios_error_noty(error, this)
              this.setOwnWarehouses([])
              this.setLoadingWarehouses(false)
              return []
            })
        },
        selectWarehouseProccess() {
            //console.log(this.own_select_warehouse)
          this.selectOwnWarehouse(this.own_select_warehouse)
        },
      },
      mounted() {
        this.allWarehouse()    
        this.own_select_warehouse = this.own_warehouse_selected
          ? _.cloneDeep(this.own_warehouse_selected)
          : null
      },
      watch: {
        own_warehouse_selected: {
          deep: true,
          immediate: true,
          handler: function (val, oldVal) {
            this.own_select_warehouse = _.cloneDeep(val) || null
          }
        },
      },
    }
    </script>
    
    <template>
      <div>
        <b-row class="pt-2 pb-0 pl-1">
          <b-col lg="6" md="12" >
            <b-form-group
              label="Bodegas"
              :label-cols-xl="label_cols_xl"
              :content-cols-xl="content_cols_xl"
            >
              <Multiselect
                v-if="own_warehouses && Object.keys(own_warehouses).length > 0"
                v-model="own_select_warehouse"
                :options="transformedWarehouses"
                placeholder="Seleccione una Bodega"
                label="text"
                track-by="text"
                @input="selectWarehouseProccess()"
                selectLabel="+"
                deselectLabel="×"
                selectedLabel="✔︎"
                :loading="loading_warehouses"
              >
              </Multiselect>
    
              <div v-if="loading_warehouses">
                <p class="p-2 text-info">
                  <!-- <span class="spinner-border spinner-border-sm text-info" small role="status"></span> -->
                  <span class="spinner-border" small role="status"></span> Cargando lista de bodegas
                </p>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </template>
    